/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {saveUserViewedDirectDepositUpsell} from '../api'

export const useMutationSaveUserViewedDirectDepositUpsell = createReactQueryMutationHook('saveUserViewedDirectDepositUpsell', saveUserViewedDirectDepositUpsell)
